// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yqg2","label":"styles_label__2lnaU"};